export default __webpack_public_path__ + "static/media/I10749.ba35a052.jpg";